export const LANDING_DISPLAYED_TESTIMONIAL_IDS = new Set<string>([
  'Mg8x-1pvR4Svy51u9PXkrw',
  'EBRzk7bsQMi-jLAB1zEp4A',
  'B34Z5zJbQSyIG1snCzJLuQ',
])
